import React from 'react'

export default function ImageModal(name, image, setShowImage) {
  return (
    <div class="container flex justify-center mx-auto">
    <div class="absolute inset-0 flex items-center justify-center bg-gray-700 bg-opacity-50">
        <div class="p-2 bg-white divide-y divide-gray-500">
            <div class="flex items-center justify-between">
                <h3 class="text-2xl">Hướng dẫn thời điểm chọn tình huống số {name}</h3>
            </div>
            <div class="mt-4">
                <img src={image} alt="" />
                <div className="flex flex-row justify-end">
                <button onClick={() => setShowImage(false)} class="my-2 p-2 text-white bg-red-600">Trở lại</button>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}
